import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import ContractSearchResults from './ContractSearchResults'
import ContractSearchPanel from './ContractSearchPanel'
import ContractSearchStore from './contract-search.store'
import staticData from '@stores/staticData.store'

const contractSearchStore = new ContractSearchStore(staticData)

export default class ContractSearch extends Component {
  render () {
    return (
      <DocumentTitle title='Contract search | Atheneum Partners'>
        <div className='expert-search'>
          <ContractSearchPanel contractSearchStore={contractSearchStore} />
          <ContractSearchResults contractSearchStore={contractSearchStore} />
        </div>
      </DocumentTitle>
    )
  }
}
